import React, { FC } from 'react';

import { UIContextProvider } from './UIContext';
import { TemplateContextProvider, StoreTemplate } from './TemplateContext';
import { UserData, UserDataContextProvider } from './UserDataContext';

export type StoreInitialState = {
  template: StoreTemplate;
  userData: UserData;
};

export const ContextProvider: FC<{ initialState: StoreInitialState }> = ({ initialState, children }) => (
  <TemplateContextProvider template={initialState.template}>
    <UIContextProvider>
      <UserDataContextProvider userData={initialState.userData}>{children}</UserDataContextProvider>
    </UIContextProvider>
  </TemplateContextProvider>
);
